import auth from '@/store/auth/module-auth-state';
import user from '@/store/user/module-user-state';
import organization from '@/store/organization/module-organization-state';
import invoice from '@/store/invoice/module-invoice-state';
import invoicefiles from '@/store/invoicefiles/module-invoicefiles-state';
import inbox from '@/store/inbox/module-inbox-state';
import notification from '@/store/notification/module-notification-state';
import supplier from '@/store/supplier/module-supplier-state';
import licenseinfo from '@/store/licenseinfo/module-licenseinfo-state';
import resource from '@/store/resources/module-resource-state';
import invoicesCheckingUpdate from '@/store/invoicesCheckingUpdate/module-invoice-checking-update-state';
import layout from '@/store/layout/module-layout-state';
import columnexport from '@/store/columnexport/module-column-export-state';
import stick from '@/store/stick/module-stick-state';
import invoicetrial from '@/store/invoicetrial/module-invoicetrial-state';
import auditinglog from '@/store/auditinglog/module-auditinglog-state';
import agreement from '@/store/licenseagreement/module-agreement-state';
import connectInvoice from '@/store/connectInvoice/module-connect-invoice-state';
import misaid from '@/store/misaid/module-misaid-state';
import settingsystem from '@/store/setting/module-setting-state';
import rolepermission from '@/store/role/module-role-state';
import outinvoice from '@/store/outinvoice/module-outinvoice-state';
import versionfeature from '@/store/versionFeature/module-feature-state';
import notificationuser from '@/store/notificationUser/module-notification-user-state';
import internal from '@/store/internal/module-internal-state';
import organizationtransferinvoice from '@/store/organizationTransferInvoice/module-organization-transfer-state';
import suppliernodowninv from '@/store/suppliernodowninv/module-supplier-no-down-state';
import supplieronlydowninv from '@/store/supplieronlydowninv/module-supplier-only-down-state';
import transferinvbytaxcode from '@/store/transferinvbytaxcode/module-transfer-inv-state';
import connecttaxaxionevent from '@/store/connecttaxaxionevent/module-connect-taxaxion-event-state';
import supplieraccepttaxauthority from '@/store/supplieraccepttaxauthority/module-supplier-accept-state';
import emailreceivealert from '@/store/emailreceivealert/module-email-receive-alert-state';
import invoicecheckhistory from '@/store/invoiceCheckHistory/module-invoice-check-history-state';
import report from '@/store/report/module-report-state';
import avareport from '@/store/avareport/module-ava-report-state';
import customsdeclaration from '@/store/customsdeclarations/module-customsdeclaration-state';
import confirmgoodsvatrate from '@/store/cofirmGoodsVatRate/module-comfirm-vat-rate-state';
import usersetup from '@/store/usersetup/module-usersetup-state';
import importModule from '@/store/import/module-import-state';
import acceptcheckingresult from '@/store/acceptCheckingResult/module-acceptcheckingresult-state';
import confirmBusiness from '@/store/confirmBusiness/module-confirm-business-state';
import subscriber from '@/store/subscriber/module-subscriber-state';
import intructionsvideo from '@/store/intructionvideo/module-intruction-video-state';
import criteriasetup from '@/store/criteriasetup/module-criteria-setup-state';
import abbreviationsetup from '@/store/abbreviationsetup/module-abbreviation-setup-state';
import analysisreport from '@/store/analysisReport/module-analysis-report';
import navigation from '@/store/navigation/module-navigation-state';
import sendtodeveloper from '@/store/sendtodeveloper/module-send-to-developer';
import notificationBanner from '@/store/module-notification-banner/module-notification-banner-state';

/**
 * Created by NVHIEN on 25/08/2025
 * Hàm chung để reset tất cả state về giá trị mặc định
 * Được sử dụng bởi mutation resetStateDefault để đảm bảo tính nhất quán
 * @returns {Object} Object chứa các state mặc định của các module cần reset
 */
export function getAllDefaultStates() {
	return {
		auth: auth,
		user: user,
		organization: organization,
		invoice: invoice,
		invoicefiles: invoicefiles,
		inbox: inbox,
		notification: notification,
		supplier: supplier,
		licenseinfo: licenseinfo,
		resource: resource,
		invoicesCheckingUpdate: invoicesCheckingUpdate,
		layout: layout,
		columnexport: columnexport,
		stick: stick,
		invoicetrial: invoicetrial,
		auditinglog: auditinglog,
		agreement: agreement,
		connectInvoice: connectInvoice,
		misaid: misaid,
		settingsystem: settingsystem,
		rolepermission: rolepermission,
		outinvoice: outinvoice,
		versionfeature: versionfeature,
		internal: internal,
		notificationuser: notificationuser,
		organizationtransferinvoice: organizationtransferinvoice,
		suppliernodowninv: suppliernodowninv,
		supplieronlydowninv: supplieronlydowninv,
		transferinvbytaxcode: transferinvbytaxcode,
		connecttaxaxionevent: connecttaxaxionevent,
		supplieraccepttaxauthority: supplieraccepttaxauthority,
		emailreceivealert: emailreceivealert,
		invoicecheckhistory: invoicecheckhistory,
		report: report,
		customsdeclaration: customsdeclaration,
		confirmgoodsvatrate: confirmgoodsvatrate,
		usersetup: usersetup,
		avareport: avareport,
		import: importModule,
		acceptcheckingresult: acceptcheckingresult,
		confirmBusiness: confirmBusiness,
		subscriber: subscriber,
		intructionsvideo: intructionsvideo,
		criteriasetup: criteriasetup,
		abbreviationsetup: abbreviationsetup,
		analysisreport: analysisreport,
		// Module navigation là ephemeral — không persist vào IndexedDB, luôn reset về null sau F5
		navigation: navigation,
		sendtodeveloper: sendtodeveloper,
		notificationBanner: notificationBanner
	};
}
